import { lazy } from 'react';
import { useRoutes } from 'react-router-dom';
import Loadable from '../theme/widgets/Loadable';

// routes
import AdministratorRoutes from './AdministratorRoutes';
import RequestorRoutes from './RequestorRoutes';
import SessionRoutes from './SessionRoutes';
import SignatoryRoutes from './SignatoryRoutes';

const NotFound = Loadable(lazy(() => import('../pages/session/NotFound')));

const NotFoundRoute = {
  path: '*',
  element: <NotFound />,
};

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([AdministratorRoutes, RequestorRoutes, SessionRoutes, SignatoryRoutes, NotFoundRoute]);
}